import { io, Socket } from 'socket.io-client';
import { WS_URL } from '@/config/runtime-config';

let socket: Socket | null = null;

/**
 * Returns a singleton Socket.IO client connected to the /collaboration namespace.
 * The auth token is read from localStorage on each (re)connection attempt.
 */
export function getSocket(): Socket {
  if (socket) return socket;

  socket = io(`${WS_URL}/collaboration`, {
    auth: {
      token: localStorage.getItem('access_token') ?? '',
    },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    transports: ['websocket', 'polling'],
  });

  // Refresh the auth token before every reconnection attempt so that
  // a renewed token is picked up automatically.
  socket.on('reconnect_attempt', () => {
    if (socket) {
      socket.auth = {
        token: localStorage.getItem('access_token') ?? '',
      };
    }
  });

  return socket;
}

/**
 * Tear down the singleton socket (e.g. on logout).
 */
export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
